<template>
  <div class="ccui-app-container">
    <div
      class="ccui-advanced-search-wrapper ccui-clearfix"
      ref="advancedSearchWrapper"
    >
      <div class="ccui-search-wrapper">
        <div class="ccui-tab-wrapper">
          <el-button
            size="mini"
            type="table-top"
            @click="
              $router.push('/baseOpera/qualification/qualificationEngineering')
            "
            >工程类</el-button
          >
          <el-button type="table-top-active" size="mini"> 物资类 </el-button>
          <el-button
            type="table-top"
            size="mini"
            @click="
              $router.push('/baseOpera/qualification/qualificationService')
            "
          >
            服务类
          </el-button>
        </div>
        <div class="ccui-extend-btn">
          <el-button
            size="mini"
            type="primary"
            icon="icon-ccui-add-sup"
            @click="qualificationFileHandle()"
            >维护资质文件</el-button
          >
          <el-button
            size="mini"
            type="primary"
            icon="icon-ccui-edit"
            @click="qualificationRequireHandle()"
            >维护资质要求</el-button
          >
        </div>
      </div>
    </div>
    <div class="tab-text">各供应商申请与本单位合作时的资质文件要求</div>
    <div class="ccui-multifunctional-table-wrapper">
      <el-table
        :data="tableData"
        row-key="id"
        border
        :max-height="tableMaxHeight"
        class="ccui-multifunctional-table"
        :default-expand-all="true"
      >
        <el-table-column
          :show-overflow-tooltip="true"
          prop="supplierTypeName"
          label="供应商分类"
          width="180"
          :treeType="itemChildren && itemChildren.length === 0 ? '' : 'default'"
        >
        </el-table-column>
        <el-table-column
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
          :key="index"
          v-for="(item, index) in qualificationFileList"
        >
          <template slot-scope="scope">
            <el-checkbox
              disabled
              v-if="scope.row.children.length <= 0"
              :value="getCheckboxStatus(item.id, scope.row.id)"
            ></el-checkbox>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!--    维护资质文件弹框-->
    <file-dialog
      @fileDialogSure="fileDialogSure"
      @fileDialogCancel="fileDialogCancel"
      @fileDialogManage="fileDialogManage"
      v-if="fileDiaShow"
      v-bind:qualificationFileList="qualificationFileList"
    >
    </file-dialog>
    <!--    资质要求弹框-->
    <require-dialog
      @requireDialogSure="requireDialogSure"
      @requireDialogCancel="requireDialogCancel"
      @diaCheckData="diaCheckData"
      v-if="requireDiaShow"
      acvivetab="B"
      class="ff"
    >
    </require-dialog>
  </div>
</template>

<script>
import requireDialog from "../../components/baseOpera-digRequire";
import fileDialog from "../../components/baseOpera-qualificationFiledig";
import {
  qrySupplierClassifyTree,
  qryAptitudeFile,
  qryAptitudeRequire
} from "../../api/appSet";

export default {
  components: {
    requireDialog,
    fileDialog
  },
  data() {
    return {
      checkboxData: [],
      btnList: ["物资供应商", "装备供应商", "分包商"],
      tableData: [],
      fileDiaShow: false,
      requireDiaShow: false,
      tableMaxHeight: 0,
      qualificationFileList: [], //资质文件列表
      itemChildren: []
    };
  },

  mounted() {
    this.handleSizeBegin();
    this.getList();
  },
  computed: {
    orgId() {
      return this.$store.getters.userDetal.orgId;
    }
  },
  watch: {
    orgId(newVal, oldVal) {
      this.getList();
    }
  },
  methods: {
    handleSizeBegin() {
      this.$nextTick(() => {
        this.computeTableHeight();
      });
      // 浏览器调整大小时，表格高度实时改变
      window.onresize = () => {
        this.computeTableHeight();
      };
    },
    // 计算表格高度方法
    computeTableHeight() {
      // 获取表格所占区域的总高度
      let appContainerHeight = document.documentElement.clientHeight - 160 - 25;
      // 获取搜索区域的高度
      this.tableMaxHeight =
        appContainerHeight - 90 > 0 ? appContainerHeight - 95 : 0;
    },
    getList() {
      // 基础数据-查询供应商类型树
      const obj = {
        supplierTypeCode: "B",
        ownOrgId: this.orgId
      };
      qrySupplierClassifyTree(obj).then(res => {
        console.log(res.data.data);
        if (res.data.data.length > 0) {
          this.tableData = res.data.data;
          this.tableData.some(item1 => {
            // 为了判断分类名称树的样式，如果有箭头，则左边有空格，否则左对齐
            if (item1.children.length !== 0) {
              this.itemChildren.push(item1.children);
            }
          });
        }
      });
      // 资质要求-根据采购单位查询资质文件
      const objFile = { isDisplayDefault: 1 };
      this.qualificationFileList = [];
      qryAptitudeFile(objFile).then(res => {
        res.data.data.aptitudeFiles.forEach(function(item, i) {
          item.label = item.aptitudeName;
          item.prop = "gradeFile";
        });
        this.qualificationFileList = [...res.data.data.aptitudeFiles];
        console.log(this.qualificationFileList);
      });
      // 被选中的资质接口
      const objRequire = { tabId: "B" };
      qryAptitudeRequire(objRequire).then(res => {
        this.checkboxData = res.data.data;
      });
    },
    getTree(obj = {}) {
      return qrySupplierClassifyTree(obj);
    },

    getCheckboxStatus(aptitudeId, supplierId) {
      let isCheck = this.checkboxData.some((value, index, array) => {
        return (
          value.aptitudeId === aptitudeId && value.supplierId === supplierId
        );
      });
      return isCheck;
    },
    qualificationFileHandle() {
      this.fileDiaShow = true;
    },
    qualificationRequireHandle() {
      this.requireDiaShow = true;
    },
    fileDialogSure(val, tableData) {
      this.fileDiaShow = false;
      this.getList();
    },
    fileDialogCancel(val) {
      this.fileDiaShow = val;
    },
    requireDialogSure(val) {
      this.requireDiaShow = val;
    },
    requireDialogCancel(val) {
      this.requireDiaShow = val;
    },
    fileDialogManage(val) {
      this.qualificationFileList = val;
    },
    // 弹框修改资质文件后更新页面数据
    diaCheckData(val) {
      this.getList();
    }
  }
};
</script>

<style scoped lang="scss">
.tab-text {
  color: #4a4a4a;
  margin: -3px 0 20px 0;
  font-size: 13px;
}
</style>
